export enum FeeMode {
  SENDER_PAYS,
  RECEIVER_PAYS,
}
